import {z} from 'zod';

import {isNil} from 'ramda';

import type {PricedItemBatchEntry} from '../types/PricedItemBatchEntry';
import {trimSwitchWithNewItemRowMessage} from '../types/PricedItemGroupRefusal';

const TRIM_SWITCH_WITH_NEW_ITEM_ROW = 'trimSwitchWithNewItemRow';

const batchRefusal = z.object({
  data: z.object({
    errors: z
      .array(z.object({reason: z.string().optional(), trimId: z.string().optional()}))
      .optional(),
  }),
});

/**
 * The message of a `trimSwitchWithNewItemRow` refusal of the BE (`DMS-NV-CT-0078` with `reason` and
 * `trimId`), with the name of the trim whose publication switch is one of `entries`: the same text
 * as the add-time refusal. None for another error, or for a trim that no entry switches.
 */
export const trimSwitchRefusalMessage = (error: unknown, entries: PricedItemBatchEntry[]) => {
  const trimId = batchRefusal
    .safeParse(error)
    .data?.data.errors?.find(({reason}) => reason === TRIM_SWITCH_WITH_NEW_ITEM_ROW)?.trimId;
  const trim = isNil(trimId)
    ? undefined
    : entries.find(({switchedTrim}) => switchedTrim?.id === trimId)?.switchedTrim;
  return isNil(trim) ? undefined : trimSwitchWithNewItemRowMessage(trim.name);
};
